<template lang="pug">
  div.panel-dashboard__legend
      span.panel-dashboard__close(@click='closeLegend')
        ods-icon.iconClose(name="close" size="20")
      div.containerDataPopup()
        ods-row(type="flex" justify='space-between')
          span.containerDataPopup__titular {{ $t(datosLegend.name) }}
        ods-col.legend(v-if="datosLegend.cat != 'mapHot'" class="mapAlert")
          // datos de mapa de puntos Alert
          ods-row.legend__img(type="flex" justify='left')
            div.custom-icon-vertical(v-if="datosLegend.component === 'CRM'")
              img(:src="require('@/assets/images/icon/ico_complaint_blue.svg')").dinamic
            div.custom-icon-vertical(v-else-if="datosLegend.component === 'CruisesMain'")
              img(:src="require('@/assets/images/icon/ico_fleet_blue.svg')").dinamic
            span {{  $t(datosLegend.img) }}
          ods-row.legend__info(type="flex" justify='left')
            div.legend__alert
              div.containerDataPopup__nameAlert(:class='datosLegend.primary')
              span {{ $t(datosLegend.textColorPrimary) }}
            div.legend__alert
              div.containerDataPopup__nameAlert(:class='datosLegend.medium')
              span {{ $t(datosLegend.textColorMedium) }}
            div.legend__alert
              div.containerDataPopup__nameAlert(:class='datosLegend.alert')
              span {{ $t(datosLegend.textColorAlert) }}
        ods-col.legend__hot(v-else)
          // datos de Mapa de calor
          ods-row.legend__img(type="flex" justify='left')
            span.colorGradiant
            div.custom-icon-vertical(v-if="datosLegend.component === 'CRM'")
              //img(:src="require('@/assets/images/icon/ico_complaint_blue.svg')").dinamic
          ods-row.legend__info(type="flex" justify='left')
            div.legend__alert
              // div.containerDataPopup__nameAlert(:class='datosLegend.primary')
              span {{ $t(datosLegend.value1) }}
            div.legend__alert
              // div.containerDataPopup__nameAlert(:class='datosLegend.medium')
              span {{ $t(datosLegend.value2) }}
            div.legend__alert
              // div.containerDataPopup__nameAlert(:class='datosLegend.alert')
              span {{ $t(datosLegend.value3) }}
            div.legend__alert
              // div.containerDataPopup__nameAlert(:class='datosLegend.alert')
              span {{ $t(datosLegend.value4) }}
</template>

<script>
import StatusCero from '@/components/StatusCero'
import image from '@/assets/images/icon/ico_complaint.svg'

export default {
  name: 'PopUpCrm',
  data () {
    return {
      datosPopup: [],
      url: undefined,
      nameImg: '',
      image: image,
      verticalName: this.$route.matched[0].name
    }
  },
  props: {
    datosLegend: {
    }
  },
  computed: {
    classIcon () {
      // this.iconLines = 'iconLines line'
      // console.log('cuantas veces.......', this.datosLegend)
      return 'iconLines line'
    }
    // ,
    // getDatos (){
    //   return this.datosPopup = this.datosLegend
    // }
  },
  watch: {
    // getDatos (val) {
    //   this.datosPopup = val
    //   console.log('datos de watch-------------->', this.datosPopup);
    // }
  },
  methods: {
    closeLegend () {
      this.$emit('closePopUp')
      var eventSetBus = new CustomEvent('setPopupBusLine', { detail: false })
      document.dispatchEvent(eventSetBus)
    }
  },
  components: {
    StatusCero
  },
  mounted () {
    console.log(this.$route.matched[0].name)
    console.log('cuantas veces.......', this.datosLegend)
  }
}
</script>

<style lang="scss">
.panel-dashboard{
  &__legend{
    position: absolute;
    left: rem(0);
    bottom: rem(0);
    z-index: 2;
    margin: 0 0 rem(70) rem(20);
    background: #fff;
    padding: rem(20);
    border-radius: rem(4);
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.05);
    min-width: rem(170);
    /* box-shadow: 3px 3px 8px #dedede; */
  }
  &__close{
    text-align: right;
    display: inline-block;
    width: 100%;
    .iconClose{
      cursor: pointer;
    }
  }
}

.containerValuesPopupLegend{
  &__busStopWrap{
      display: flex;
      align-items: center;
      position: relative;
      /* justify-content: center; */
      .line{
        background: #048412;
        height: rem(31);
        width: rem(6);
        display: inline-block;
        position: absolute;
        top: rem(10);
        left: rem(2);
        z-index: -1;
      }
  }
  &__busStopWrap:last-child .line{
    background: rgb(253, 253, 253);
    height: rem(11);
    top: rem(11);
  }
  &__busStop{
    background: #fff;
    border: solid rem(2) #048412;
    border-radius: 50%;
    height: rem(6);
    width: rem(6);
    display: inline-block;
  }
  .ods-scrollbar{
    height: calc(100vh - 444px);
    width: rem(372);
  }
  .ods-accordion-item{
    padding: 0;
    border: none;
    &__wrap{
      overflow: visible;
    }
    &__header{
      font-weight: normal;
    }
  }
}
#popup {
  background: $--color-white;
  border-radius: rem(5);
  bottom: rem(16);
  // display: none;
  // left: calc(24px + 72px);
  left: rem(16);
  // padding-right: rem(24);
  padding: rem(16) rem(32);
  padding-top: rem(32);
  position: absolute;
  transition: width 0.4s, min-width 0.4s, opacity 0.4s;
  width: auto;
  z-index: 10;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
  .iconClose {
    cursor: pointer;
    position: absolute;
    top: rem(8);
    right: rem(8);
  }
}
.containerDataPopup {
    /* border-bottom: 1px solid $--color-neutral-3; */
    padding-bottom: rem(16);
    margin-bottom: rem(5);
    margin-right: rem(8);
    font-weight: 500;
    &__titular{
      font-size: rem(12);
    }
    &__nameAlert{
      color: #fff;
      border-radius: rem(4);
      width: rem(16);
      display: inline-block;
      height: rem(16);
      text-align: center;
      margin-right: rem(10);
    }
    .primary{
      background: #2E6C99;
    }
    .medium{
      background-color: #ED8D2F;
    }
    .alert{
      background-color: #CC1818;
    }
    .ods-row--flex{
      align-items: center;
    }
    .legend{
      display: flex;
      margin-top: rem(20);
      justify-content: space-between;
      &__img{
        font-weight: 400;
        align-items: normal;
        .custom-icon-vertical{
          border-radius: 50%;
          border: solid 1px $--color-blue-dark;
          background: #f3f3f3;
          width: rem(32);
          height: rem(32);
          display: flex;
          justify-content: center;
          margin-right: rem(10);
        }
        span{
          margin-top: 9px;
          font-size: rem(12)
        }
      }
      &__info{
        flex-direction: column;
        align-items: baseline;

      }
      &__alert{
        font-weight: 400;
        display: flex;
        align-items: center;
        padding: rem(5);
        font-size: rem(12)
      }
      &__hot{
        display: flex;
        padding: 10px 0;
        .legend__img{
          padding: 10px 0;
          .colorGradiant{
            border-radius: 8px;
            margin: 0;
            width: 8px;
            background: linear-gradient(180deg, #E37A7A 0%, #F8E97C 29.56%, #A4DFE6 64.27%, #D5CEF0 100%);
          }
        }
        .legend__info{
          padding: 0 0 0 20px;
          .legend__alert{
            line-height: 20px;
          }
        }
      }
    }
    .mapAlert{
      .legend__img{
        margin-right: 47px;
      }
    }
  }
  .containerValuesPopupLegend{
    // min-height: rem(50);
  }

.maxSizePopup {
  // max-height: rem(100);
  // padding-right: rem(24);
  text-transform: uppercase;
  div {
    margin-bottom: rem(16);
    font-size: rem(10);
    .tipo {
      font-weight: bold;
      margin-right: rem(8);
      &::before{
        background: #048412;
        height: rem(10);
        width: rem(5);
        display: inline-block;
        position: absolute;
      }
    }
    .valor {
      color: $--color-grey-dark;
      font-size: rem(11);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PopUpCrm.vue